import { SparklesIcon } from '@heroicons/react/24/outline';

type SupportAiSuggestButtonProps = {
  suggesting?: boolean;
  disabled?: boolean;
  label?: string;
  busyLabel?: string;
  title?: string;
  onClick: () => void;
};

export function SupportAiSuggestButton({
  suggesting = false,
  disabled = false,
  label = 'Sugerir com IA',
  busyLabel = 'Gerando…',
  title = 'Sugerir texto com IA a partir do contexto do chamado',
  onClick,
}: SupportAiSuggestButtonProps) {
  return (
    <button
      type="button"
      className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium text-orange-700 transition-colors hover:bg-orange-50 disabled:opacity-50"
      onClick={onClick}
      disabled={disabled || suggesting}
      title={title}
    >
      <SparklesIcon className={`h-4 w-4 ${suggesting ? 'animate-pulse' : ''}`} />
      {suggesting ? busyLabel : label}
    </button>
  );
}
